<mat-card appearance="raised" class="cart-summary mt-2 mt-lg-0 ds-migration">
    <mat-card-title class="subtitle mat-headline-6 m-0">Balance</mat-card-title>
    @if (isAllowedMultipleAWBs) {
        <app-lib-awbs-list />
        <mat-divider class="mt-4 mb-4" />
    }
    <section class="summary-fees d-flex flex-column">
        @if (subTotal) {
            <div class="mb-3">
                <app-fee [size]="'medium'" [valueBold]="true" [feeLabel]="'Subtotal'" [feeValue]="subTotal"></app-fee>
            </div>
        }
        @if (!!titleCustomFees && hasConvenienceFeesWithValue) {
            <div class="mat-subtitle-2 m-0 mb-1">{{ titleCustomFees }}</div>
        }
        @for (fee of convenienceFees; let feeIndex = $index; track feeIndex) {
            @if (
                !fee.extraFee &&
                fee.feeValue > 0 &&
                !(nonReservationFee === 0 && fee.feeName === cartFees.NON_RESERVATION_FEE) &&
                !fee.isDisplayedSeparately
            ) {
                <div class="summary-items-fees mt-1">
                    <app-fee
                        [valueBold]="true"
                        [feeLabel]="fee.feeLabel"
                        [feeValue]="fee.feeValue"
                        [feeInfoTooltip]="fee.feeInfoTooltip"
                        [getFeeInfoTooltip]="fee.getFeeInfoTooltip"
                        [getFeeInfoTooltipHTML]="fee.getFeeInfoTooltipHTML"
                    />
                </div>
            }
        }
        @for (fee of convenienceFees; let feeIndex1 = $index; track feeIndex1) {
            @if (
                !fee.extraFee &&
                fee.feeValue > 0 &&
                !(nonReservationFee === 0 && fee.feeName === cartFees.NON_RESERVATION_FEE) &&
                fee.isDisplayedSeparately
            ) {
                <mat-divider class="mt-4 mb-4"></mat-divider>
                <div class="summary-items-fees mt-1">
                    <app-fee
                        [valueBold]="true"
                        [feeLabel]="fee.feeLabel"
                        [feeValue]="fee.feeValue"
                        [feeInfoTooltip]="fee.feeInfoTooltip"
                        [getFeeInfoTooltip]="fee.getFeeInfoTooltip"
                        [getFeeInfoTooltipHTML]="fee.getFeeInfoTooltipHTML"
                    />
                </div>
            }
        }
        <!-- Ends section for items with isDisplayedSeparately property active -->

        <mat-divider class="mt-4 mb-4"></mat-divider>

        @if (customSubtotal) {
            <div class="mb-3">
                <app-fee [valueBold]="true" [feeLabel]="customSubtotalTitle" [feeValue]="chargeAndFeesSubTotal" />
            </div>
        }
        @for (fee of convenienceFees; let feeIndex2 = $index; track feeIndex2) {
            @if (fee.extraFee && fee.feeValue > 0) {
                <div class="summary-items-fees mb-3">
                    <app-fee
                        [valueBold]="true"
                        [feeLabel]="fee.feeLabel"
                        [feeValue]="fee.feeValue"
                        [feeInfoTooltip]="fee.feeInfoTooltip"
                        [getFeeInfoTooltip]="fee.getFeeInfoTooltip"
                        [getFeeInfoTooltipHTML]="fee.getFeeInfoTooltipHTML"
                    />
                </div>
            }
        }
        <!-- START: LENDINGFEE -->
        @if (isFinanceEnabled && isPaymentMethodSelectedValid && cartBill && lendingFeeTotal > 0 && !invoicesInCart) {
            <div class="summary-items-fees">
                <app-fee
                    [valueBold]="true"
                    [feeLabel]="`SprintPay Flex Finance Fee (${lendingRate}%):`"
                    [feeValue]="lendingFeeTotal"
                />
            </div>
        }
        @if (cartBill && !invoicesInCart && (SPFUnderLimitRate || SPFOverLimitRate) && !isFinanceEnabled) {
            <mat-divider class="w-100 mb-3" />
            <div class="d-flex justify-content-start flex-column align-items-center">
                @if (SPFUnderLimitRate) {
                    <div class="w-100" [ngClass]="{ 'mb-3': SPFOverLimitRate }">
                        <app-fee
                            [valueBold]="true"
                            [feeLabel]="'SprintPay Flex Finance Fees:'"
                            [feeValue]="SPFUnderLimitFee"
                        ></app-fee>
                        <p class="mb-0 paymente-rates">
                            {{ SPFUnderLimitSubTotal | currency: 'USD' : 'symbol' }} at {{ SPFUnderLimitRate }}%
                        </p>
                    </div>
                }
                @if (SPFOverLimitRate) {
                    <div class="w-100">
                        <app-fee
                            [valueBold]="true"
                            [feeLabel]="'SprintPay Flex Finance Fees:'"
                            [feeValue]="SPFOverLimitFee"
                        ></app-fee>
                        <p class="mb-0 paymente-rates">
                            {{ SPFOverLimitSubTotal | currency: 'USD' : 'symbol' }} at {{ SPFOverLimitRate }}%
                        </p>
                    </div>
                }
            </div>
            <mat-divider class="w-100 my-3" />
        }
        @if (cartBill && taxAmountTotal !== undefined && taxAmountTotal > 0) {
            <app-fee
                [valueBold]="true"
                [feeLabel]="'Sales Tax:'"
                [feeValue]="taxAmountTotal"
                [feeInfoTooltip]="
                    'Sales tax applies to the handling fee based on state and local requirements for your address.'
                "
            ></app-fee>
            <mat-divider class="w-100 my-3" />
        }
        @if (shouldShowConvenienceFeesDivider) {
            <mat-divider class="mt-4 mb-4"></mat-divider>
        }
        @if (cartBill && cartBill.total && (paymentMethodBelowThreshold || paymentMethodAboveThreshold)) {
            <div class="total-container rounded d-flex flex-row align-items-center">
                <h2 class="total-description mb-0 me-3">TOTAL:</h2>
                <h2 class="total-amount mb-0">USD {{ cartBill.total | currency }}</h2>
            </div>
        }
        <!-- START: LEDING DISCLAIMER -->
        <div class="space"></div>
        @if (
            (paymentMethodBelowThreshold === paymentMethods.FINANCE ||
                paymentMethodAboveThreshold === paymentMethods.FINANCE) &&
            isPaymentMethodSelectedValid
        ) {
            <div class="d-flex justify-content-start flex-row align-items-center mb-3">
                @if (lendingTerms && cartBill && cartBill.total) {
                    <div
                        class="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100 p-2 p-md-0"
                    >
                        <div
                            class="flex-grow-1 mat-subtitle-1 m-0 d-block text-start lending-disclaimer"
                            [innerHTML]="financeDisclaimer"
                        ></div>
                    </div>
                }
            </div>
        }
        <!-- END: LEDING DISCLAIMER -->
        <app-lib-cart-alert />
        @if (cartNote) {
            <app-lib-notes [showError]="true" [notesText]="cartNote" [showCheckbox]="cartNoteWithCheckbox" />
        }
        @if (termsOfUseURL || sprintPayFlexButtonText) {
            <mat-divider class="mt-4 mb-4" />
        }
        <!-- START: TERMS OF USE CHECKBOX AND FINANCE -->
        <div class="terms-and-finance">
            @if (termsOfUseURL) {
                <div class="me-2 flex-grow-1">
                    <app-terms-of-use [showError]="true"> </app-terms-of-use>
                </div>
            }
            @if (sprintPayFlexEnabled) {
                <app-lib-request-finance-button
                    [sprintPayFlexButtonText]="sprintPayFlexButtonText"
                ></app-lib-request-finance-button>
            }
        </div>
        <!-- END: TERMS OF USE CHECKBOX AND FINANCE -->
        <!-- START: PAY BUTTON AND WARNING -->
        @if (
            paymentMethodBelowThreshold !== paymentMethods.PAYPAL &&
            paymentMethodAboveThreshold !== paymentMethods.PAYPAL
        ) {
            <div class="mt-3">
                <app-lib-pay-button (eventSubmitPayment)="submitPayment()" />
                @if (
                    !isInvoiceCheckLimitValid &&
                    (paymentMethodBelowThreshold === paymentMethods.CARGO_CREDIT ||
                        paymentMethodBelowThreshold === paymentMethods.SPRINTPAY_FLEX)
                ) {
                    <span
                        class="d-flex align-items-center justify-content-center p-3 mt-3 fw-normal payment-warning__msg"
                        ><span class="material-symbols-outlined me-1">exclamation</span>Your total request is over the
                        limit of your total balance available limit, please send an email to:
                        support&#64;cargosprint.com</span
                    >
                }
            </div>
        }
        <!-- END: PAY BUTTON AND WARNING -->
        <!-- START: PAYPAL -->
        @if (paymentMethodBelowThreshold === paymentMethods.PAYPAL && !isCartAboveThreshold) {
            <div class="my-3">
                <app-lib-paypal-button (eventPay)="payWithPaypal($event)" />
            </div>
        }

        <!-- Custom content template - allows users to add any component after PayPal button -->
        <ng-content select="[slot=after-pay-button]"></ng-content>
    </section>
</mat-card>
